import React, { useState, useEffect, useMemo } from "react";
import {
  FaEdit,
  FaTrash,
  FaFileInvoice,
  FaCalendarCheck,
  FaSearch,
  FaSignOutAlt,
} from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import "../home_alumnos/alumnos.css";
import Swal from "sweetalert2";
import {
  create_student,
  unlink_student,
  update_student,
} from "../services/services";
import Loading from "../utils/loading";
import { Login, setData } from "../services/login.service";
import { ModalFacturas } from "../administrador/modal_facturas";
import { ModalAsistencias } from "../home_alumnos/modal_asistencias_alumno";


const AdminUsers = () => {
  const usuario = JSON.parse(localStorage.getItem("credenciales"));
  const [flag, setFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);

  // Estados para controlar la visibilidad de los modales
  const [isFacturasModalOpen, setIsFacturasModalOpen] = useState(false);
  const [isAsistenciasModalOpen, setIsAsistenciasModalOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  // Pagination and Filtering States
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterStatus, setFilterStatus] = useState("Todos");

  // Manejadores para los clicks en los iconos
  const handleInvoiceClick = (user) => {
    setSelectedUserId(user.id);
    setIsFacturasModalOpen(true);
  };

  const handleAttendanceClick = (user) => {
    setSelectedUserId(user.id);
    setIsAsistenciasModalOpen(true);
  };

  // Initial Form State
  const initialFormState = {
    id: "",
    name: "",
    vat: "",
    phone: "",
    identification_type: "Cédula de ciudadanía",
    street: "",
    email: "",
    birthday: "",
  };

  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState(initialFormState);
  const [isEditing, setIsEditing] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  // Logout Handler
  const handleLogout = () => {
    Swal.fire({
      title: "¿Estás seguro de cerrar sesión?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#000000",
      cancelButtonColor: "#807e80",
      confirmButtonText: "Sí, cerrar sesión",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        // Clear local storage
        localStorage.removeItem("credenciales");
        localStorage.removeItem("students");

        // Redirect to login page
        window.location.href = "/"; // Adjust the path as needed
      }
    });
  };

  // Filtering and Pagination Logic
  const filteredUsers = useMemo(() => {
    return users.filter((user) => {
      const matchesSearch =
        user.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        false ||
        user.vat?.toString().includes(searchTerm) ||
        false ||
        user.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        false;

      const matchesStatus =
        filterStatus === "Todos" || user.estado === filterStatus;

      return matchesSearch && matchesStatus;
    });
  }, [users, searchTerm, filterStatus]);

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Fetch data on component mount
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      // Añadir un temporizador artificial
      await new Promise((resolve) => setTimeout(resolve, 2000)); // 1.5 segundos de tiempo de carga

      await Login(
        { user: usuario.user, password: usuario.password },
        (response) => {
          let result = JSON.parse(localStorage.getItem("students"));
          console.log("respuesta", result.student);
          if (response) {
            setUsers(result.student || []);
          } else {
            console.error("Error al cargar los datos:", response);
          }
          setLoading(false);
        }
      );
    };
    fetchData();
  }, [usuario.user, usuario.password]);
  // useEffect(() => {
  //   const fetchData = async () => {
  //     setLoading(true);
  //     await Login(
  //       { user: usuario.user, password: usuario.password },
  //       (response) => {
  //         if (response) {
  //           setUsers(JSON.parse(localStorage.getItem("students")) || []);
  //         } else {
  //           console.error("Error al cargar los datos:", response);
  //         }
  //         setLoading(false);
  //       }
  //     );
  //   };

  //   fetchData();
  // }, [usuario.user, usuario.password]);

  // Create user modal handler
  const handleCreateUser = () => {
    setFormData(initialFormState);
    setIsEditing(false);
    setShowModal(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Asegurar que los campos tengan valores por defecto
    const sanitizedFormData = {
      ...formData,
      name: formData.name || "",
      vat: formData.vat || "",
      email: formData.email || "",
    };

    if (isEditing) {
      update_student(sanitizedFormData, usuario, (res, flag) => {
        if (flag) {
          window.location.reload();
        }
      });
    } else {
      create_student(sanitizedFormData, usuario, (res, flag) => {
        window.location.reload();
      });
    }

    setShowModal(false);
    setFormData(initialFormState);
  };

  // Edit user handler
  const handleEdit = (index) => {
    const userToEdit = users[index];
    setFormData(userToEdit);
    setIsEditing(true);
    setEditIndex(index);
    setShowModal(true);
  };

  // Modified Delete user handler with SweetAlert
  const handleDelete = (index) => {
    const userToDelete = {
      id: users[index].id,
    };

    // Show confirmation dialog
    Swal.fire({
      title: "¿Estás seguro(@)?",
      text: `Estás a punto de eliminar al deportista ${users[index].name}. Esta acción no se puede deshacer.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#000000",
      cancelButtonColor: "#807e80",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        // If confirmed, proceed with deletion
        unlink_student(userToDelete, usuario, (flag, res) => {
          if (flag) {
            // Show success alert
            Swal.fire(
              "Eliminado",
              "El deportista ha sido eliminado exitosamente.",
              "success"
            );
            window.location.reload();
          } else {
            // Show error alert if deletion fails
            Swal.fire(
              "Error",
              "No se pudo eliminar el deportista. Intente nuevamente.",
              "error"
            );
            console.log("Deletion failed", flag, res);
          }
        });
      }
    });
  };

  // Pagination Calculation
  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(filteredUsers.length / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <div className="admin-users-page">
      {/* Logout Button in Top Right Corner */}
      <div
        className="logout-container"
        style={{
          position: "absolute",
          top: "22px",
          right: "109px",
          zIndex: 1000,
        }}
      >
        <button
          className="logout-btn"
          onClick={handleLogout}
          title="Cerrar Sesión"
        >
          <FaSignOutAlt /> Salir
        </button>
      </div>

      <div className="bg-image"></div>
      <div className="content-wrapper1">
        {/* <FloatingMessage /> */}
        <h1 className="tittle ancho">Administrar deportistas</h1>

        {/* Search and Filter Section */}
        <div className="d-flex justify-content-between mb-3">
          {/* <button className="create-user-button" onClick={handleCreateUser}>
            Crear deportista
          </button> */}

          <div className="d-flex">
            <div className="input-group me-2 buscador">
              <span className="input-group-text ">
                <FaSearch />
              </span>
              <input
                type="text"
                className="form-control"
                placeholder="Buscar por nombre, documento o email"
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
        </div>

        <div className="table-wrapper">
          <table className="users-table">
            <thead style={{ backgroundColor: "#6c757d", color: "white" }}>
              <tr>
                <th>#</th>
                <th className="nombre_mobile">Nombre completo</th>
                <th className="hide-mobile">Tipo Documento</th>
                <th className="hide-mobile">Documento</th>
                <th className="hide-mobile">Fecha nacimiento</th>
                <th>Telefono</th>
                <th>Email</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {currentUsers.map((user, index) => (
                <tr key={user.id || index}>
                  <td>{indexOfFirstItem + index + 1}</td>
                  <td>{user.name}</td>
                  <td className="hide-mobile">{user.identification_type}</td>
                  <td className="hide-mobile">{user.vat}</td>
                  <td className="hide-mobile">{user.birthday}</td>
                  <td>{user.phone}</td>
                  <td>{user.email}</td>
                  <td>
                    <div className="action-icons">
                      {/* <FaEdit
                        className="edit-icon"
                        onClick={() => handleEdit(indexOfFirstItem + index)}
                        title="Editar"
                      />
                      <FaTrash
                        className="delete-icon"
                        onClick={() => handleDelete(indexOfFirstItem + index)}
                        title="Eliminar"
                      /> */}
                      <FaFileInvoice
                        className="invoice-icon"
                        onClick={() => handleInvoiceClick(user)}
                        title="Factura"
                      />
                      <FaCalendarCheck
                        className="attendance-icon"
                        onClick={() => handleAttendanceClick(user)}
                        title="Asistencia"
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <nav className="d-flex ">
        
          <ul className="pagination">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button
                className="page-link"
                onClick={() => paginate(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Anterior
              </button>
            </li>
            {pageNumbers.map((number) => (
              <li
                key={number}
                className={`page-item ${
                  currentPage === number ? "active" : ""
                }`}
              >
                <button
                  onClick={() => paginate(number)}
                  className="page-link"
                  style={{
                    color: currentPage === number ? "black" : "",
                  }}
                >
                  {number}
                </button>
              </li>
            ))}
            <li
              className={`page-item ${
                currentPage === pageNumbers.length ? "disabled" : ""
              }`}
            >
              <button
                className="page-link"
                onClick={() => paginate(currentPage + 1)}
                disabled={currentPage === pageNumbers.length}
              >
                Siguiente
              </button>
            </li>
          </ul>
        </nav>
        <Loading isVisible={loading} />
        {showModal && (
          <div
            className="modal fade show"
            tabIndex="-1"
            role="dialog"
            style={{ display: "block" }}
          >
            <div
              className="modal-dialog modal-dialog-centered modal-lg"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header text-white rounded-top">
                  <h5 className="modal-title">
                    {isEditing ? "Editar Deportista" : "Crear Nuevo Deportista"}
                  </h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => setShowModal(false)}
                    aria-label="Close"
                  ></button>
                </div>
                <form onSubmit={handleSubmit} className="p-0">
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="nombre" className="form-label">
                          Nombre Completo
                        </label>
                        <input
                          type="text"
                          className="form-control gradient-border-input letra"
                          id="nombre"
                          name="name"
                          placeholder="Ingrese nombre completo"
                          value={formData.name}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="tipo_documento" className="form-label">
                          Tipo Documento
                        </label>
                        <select
                          className="form-select gradient-border-input"
                          id="tipo_documento"
                          name="identification_type"
                          value={formData.identification_type}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="Cédula de ciudadanía">
                            Cédula de Ciudadanía
                          </option>
                          <option value="Tarjeta de Identidad">
                            Tarjeta de Identidad
                          </option>
                          <option value="Registro Civil">Registro Civil</option>
                          <option value="Tarjeta de extranjería">
                            Tarjeta de extranjería
                          </option>
                          <option value="Cédula de extranjería">
                            cedula extranjería
                          </option>
                          <option value="Pasaporte">Pasaporte</option>
                        </select>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="documento" className="form-label">
                          Número Documento
                        </label>
                        <input
                          type="text"
                          className="form-control gradient-border-input"
                          id="documento"
                          name="vat"
                          placeholder="Ingrese número de documento"
                          value={formData.vat}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label
                          htmlFor="fecha_nacimiento"
                          className="form-label"
                        >
                          Fecha Nacimiento
                        </label>
                        <input
                          type="date"
                          className="form-control gradient-border-input"
                          id="fecha_nacimiento"
                          name="birthday"
                          value={formData.birthday}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="telefono" className="form-label">
                          Teléfono
                        </label>
                        <input
                          type="tel"
                          className="form-control gradient-border-input"
                          id="telefono"
                          name="phone"
                          placeholder="Ingrese número de teléfono"
                          value={formData.phone}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="correo" className="form-label">
                          Correo Electrónico
                        </label>
                        <input
                          type="email"
                          className="form-control gradient-border-input"
                          id="correo"
                          name="email"
                          placeholder="Ingrese correo electrónico"
                          value={formData.email}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setShowModal(false)}
                    >
                      Cancelar
                    </button>
                    <button type="submit" className="btn btn-primary">
                      {isEditing ? "Actualizar" : "Guardar"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* Renderizamos los modales */}
      <ModalAsistencias
        isOpen={isAsistenciasModalOpen}
        onClose={() => setIsAsistenciasModalOpen(false)}
        userId={selectedUserId}
      />
      <ModalFacturas
        isOpen={isFacturasModalOpen}
        onClose={(flag) => {
          setIsFacturasModalOpen(flag);
        }}
        userId={selectedUserId}
      />
    </div>
  );
};

export default AdminUsers;
